import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useRiskAnalysisStore = defineStore('riskAnalysis', () => {
  // 상태
  const companyName = ref('');
  const analysisResults = ref(null);
  const isLoading = ref(false);
  const error = ref(null);
  const uploadedFile = ref(null);

  // 메서드
  const setCompanyName = (name) => {
    companyName.value = name;
  };

  const setAnalysisResults = (results) => {
    analysisResults.value = results;
  };

  const setLoading = (loading) => {
    isLoading.value = loading;
  };

  const setError = (err) => {
    error.value = err;
  };

  const setUploadedFile = (file) => {
    uploadedFile.value = file;
  };

  const reset = () => {
    companyName.value = '';
    analysisResults.value = null;
    isLoading.value = false;
    error.value = null;
    uploadedFile.value = null;
  };

  return {
    companyName,
    analysisResults,
    isLoading,
    error,
    uploadedFile,
    setCompanyName,
    setAnalysisResults,
    setLoading,
    setError,
    setUploadedFile,
    reset,
  };
});
